export default __webpack_public_path__ + "static/media/ic_simpleswaps.4cd51f2a.svg";